'use strict';

(function () {
  'use strict';

  angular.module('msTracker').filter('oldScaleToNewScale', function () {
    return function (input) {
      if (input < 20) {
        return -1;
      }
      if (input >= 20 && input < 40) {
        return -0.5;
      }
      if (input >= 40 && input < 60) {
        return 0;
      }
      if (input >= 60 && input < 80) {
        return 0.5;
      }
      if (input >= 80) {
        return 1;
      }
    };
  }).filter('trackerValueToButtonIndex', ['$log', function ($log) {
    return function (input) {
      var buttonIndex = void 0;
      switch (input) {
        case -1:
          buttonIndex = 0;
          break;
        case -0.5:
          buttonIndex = 1;
          break;
        case 0:
          buttonIndex = 2;
          break;
        case 0.5:
          buttonIndex = 3;
          break;
        case 1:
          buttonIndex = 4;
          break;
        default:
          $log.debug('Tracker value was not in the set [-1,-0.5,0,0.5,1].', input);
          buttonIndex = 2;
          break;
      }
      return buttonIndex;
    };
  }]).filter('indexToTrackerValueButton', ['$log', function ($log) {
    return function (input) {
      var value = void 0;
      switch (input) {
        case 0:
          value = -1;
          break;
        case 1:
          value = -0.5;
          break;
        case 2:
          value = 0;
          break;
        case 3:
          value = 0.5;
          break;
        case 4:
          value = 1;
          break;
        default:
          $log.debug('Index value was not in the set [0,1,2,3,4].', input);
          value = 0;
          break;
      }
      return value;
    };
  }]).filter('trackerButtonIndexToLabel', ['$log', '$translate', function ($log, $translate) {
    return function (buttonIndex, inputTracker, extraData) {
      var label = void 0;
      var tracker = angular.copy(inputTracker);
      if (!inputTracker) {
        return '';
      }
      if (extraData) {
        tracker = {
          negativeLabel: tracker,
          positiveLabel: extraData
        };
      }

      // Replace single quote symbols with their codes to prevent $translate module errors;
      if (angular.isObject(tracker)) {
        tracker.negativeLabel = tracker.negativeLabel.replace('\'', '&apos;');
        tracker.positiveLabel = tracker.positiveLabel.replace('\'', '&apos;');
      }

      switch (buttonIndex) {
        case 0:
          label = tracker.negativeLabel;
          break;
        case 1:
          label = $translate.instant('common.moodButtons.almost', { label: tracker.negativeLabel });
          break;
        case 2:
          label = $translate.instant('common.moodButtons.neither', {
            low: tracker.negativeLabel,
            high: tracker.positiveLabel
          });
          break;
        case 3:
          label = $translate.instant('common.moodButtons.almost', { label: tracker.positiveLabel });
          break;
        case 4:
          label = tracker.positiveLabel;
          break;
        default:
          $log.debug('Index value was not in the set [0,1,2,3,4].', buttonIndex);
          label = 0;
          break;
      }
      return label;
    };
  }]).filter('trackerValueToChartSize', function () {
    return function (input, maxSize, minSize) {
      var outputSize;
      maxSize = maxSize || 15;
      minSize = minSize || 5;
      // We know the range of values is [-1,1]
      function normalize(x) {
        return (x - -1) / (1 - -1);
      }

      outputSize = normalize(input) * maxSize + minSize;
      return outputSize.toString() + 'px';
    };
  });
})();